import { IProjectModel } from "./model/IProjectModel";
import { Result } from "./rest_api_connection/Result";
import { ServiceBase } from "./rest_api_connection/ServiceBase";

export default class ProjectService extends ServiceBase {
    public async getProjects(
        organizationId: string
    ): Promise<Result<IProjectModel[]>> {

        let url = "/Organization/" + organizationId + "/Project";

        var result = await this.requestJson<IProjectModel[]>({
            url: url,
            method: "GET"
        });
        return result;
    }
}